export default __webpack_public_path__ + "static/media/flex_illustration.898b7584.png";